import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

/**
 * Shared department dropdown for Department module list pages.
 * Matches sizing/placement used on Class Management (size="small", minWidth 200).
 */
export default function DepartmentModuleFilterSelect({
  value,
  onChange,
  instituteId,
  showAllOption = true,
  disabled = false,
  labelId = "department-module-filter-label",
}) {
  const { data: departmentsResponse, isLoading } = useQuery({
    queryKey: ["departments-names", instituteId],
    queryFn: async () => {
      const params = {};
      if (instituteId) params.instituteId = instituteId;
      const res = await api.get("/institute/get-departments-names", { params });
      return res.data;
    },
    staleTime: 60 * 1000,
  });

  const departments = Array.isArray(departmentsResponse?.data)
    ? departmentsResponse.data
    : [];

  const selectValue =
    value === null || value === undefined || value === ""
      ? "all"
      : String(value);

  return (
    <FormControl size="small" sx={{ minWidth: 200 }} disabled={disabled || isLoading}>
      <InputLabel id={labelId}>Department</InputLabel>
      <Select
        labelId={labelId}
        id={`${labelId}-select`}
        value={selectValue}
        label="Department"
        onChange={(e) => {
          const v = e.target.value;
          onChange(v === "all" ? null : Number(v));
        }}
      >
        {showAllOption && (
          <MenuItem value="all">All departments</MenuItem>
        )}
        {departments.map((dept) => (
          <MenuItem key={dept.id} value={String(dept.id)}>
            {dept.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
